
<template>
    <modal
        :show="showModal('blockUser')"
        :renderCustomContent="true"
        :renderCloseBtn="true"
        type="blockUser"
    >
        <template v-slot:content>
<div class="block-user-modal-content" >
            <div class="block-user-modal-title">
                Block User
            </div>
            <div class="modal-content">
                    If you block this user, they will not be able to join any future games that you create.
                    <br/>
                    <br/>
                    You can unblock users from your profile page.
                </div>
            <div class="modal-footer">
                <div class="btn btn-textual cancel-btn" @click="onCloseModal">
                    Cancel
                </div>
                <div class="btn btn-primary btn-3d submit-btn" @click="onBlockUser">
                    Block
                </div>
            </div>
        </div>
</template>
    </modal>
</template>

<script>

import api from '../../helpers/api';

export default {
    name: 'BlockUserModal',
    computed: {
        data() {
            return this.$store.state.modalState.modals.blockUser.data;
        },
    },
    methods: {
        onCloseModal() {
            this.$store.dispatch('closeModal', 'blockUser');
        },
        async onBlockUser() {
            const response = await api.request(`/user/block/${this.data?.blockedUserId}`, 'POST');

            if (response.ok) {
                this.onCloseModal();

                this.$notify({
                    group: 'app',
                    title: 'Success',
                    type: 'success',
                    text: 'User successfully blocked',
                });

            } else {
                const responsePayload = await response.json();

                this.$notify({
                    group: 'app',
                    title: 'Error',
                    type: 'error',
                    text: responsePayload?.message ?? 'Error blocking user',
                });
            }
        },
        showModal(type) {
            return this.$store.state.modalState.modals[type].show;
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .block-user-modal-content {

        .block-user-modal-title {
            font-size: 1.1rem;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .modal-footer {
            margin-top: 15px;

            > * {
                margin: 0 5px;
            }
        }
    }


</style>
